var map = {
	"./alarm.svg": "2d76",
	"./app_alarm.svg": "dbc5",
	"./app_device.svg": "4a64",
	"./app_energy.svg": "bd6d",
	"./app_multi_site.svg": "40f6",
	"./app_single_site.svg": "63ff",
	"./app_value.svg": "33b6",
	"./asset.svg": "ff5d",
	"./data_analytic.svg": "76d6",
	"./device.svg": "d296",
	"./fonts/fontello/font/fontello.svg": "6556",
	"./install.svg": "bbbd",
	"./inventory.svg": "e793",
	"./markers/active_marker.svg": "5c89",
	"./markers/alarm_marker.svg": "516a",
	"./markers/normal_marker.svg": "305a",
	"./markers/offline_marker.svg": "b215",
	"./menu/home_icon.svg": "1e35",
	"./menu/login_icon.svg": "25b2",
	"./menu/menu-alarm.svg": "8ef3",
	"./menu/menu-data-analytic.svg": "6e84",
	"./menu/menu-device.svg": "f1a6",
	"./menu/menu-energy.svg": "47b6",
	"./menu/menu-inventory.svg": "2bf2",
	"./menu/menu-multiple-sites.svg": "0f86",
	"./menu/menu-schedule.svg": "0d67",
	"./menu/menu-single-site.svg": "177a",
	"./menu/menu-user.svg": "ab7f",
	"./menu/menu-values.svg": "3147",
	"./multi_site.svg": "24d1",
	"./pages/data-analytic/bess_item-v2.svg": "acab",
	"./pages/data-analytic/bess_item-v2_38x38.svg": "5efd",
	"./pages/data-analytic/bess_item.svg": "3889",
	"./pages/data-analytic/evse_item-v2.svg": "35bf",
	"./pages/data-analytic/evse_item-v2_38x38.svg": "dea3",
	"./pages/data-analytic/evse_item.svg": "402e",
	"./pages/data-analytic/grid_item-v2.svg": "c854",
	"./pages/data-analytic/grid_item-v2_38x38.svg": "c3a7",
	"./pages/data-analytic/grid_item.svg": "d395",
	"./pages/data-analytic/home_load_item-v2.svg": "32fe",
	"./pages/data-analytic/home_load_item-v2_38x38.svg": "e7da",
	"./pages/data-analytic/home_load_item.svg": "d0aa",
	"./pages/data-analytic/pv-v2.svg": "8d11",
	"./pages/data-analytic/pv_item.svg": "b580",
	"./pages/data-analytic/sumary_battery_charge.svg": "2329",
	"./pages/data-analytic/sumary_ev_charger.svg": "c783",
	"./pages/data-analytic/sumary_grid-v2.svg": "0153",
	"./pages/data-analytic/sumary_grid.svg": "1680",
	"./pages/data-analytic/sumary_house_load.svg": "b30e",
	"./pages/data-analytic/summary_battery_export.svg": "4884",
	"./pages/data-analytic/summary_battery_import.svg": "41a1",
	"./pages/data-analytic/summary_pv.svg": "9f81",
	"./pages/data-saving/baht_unit.svg": "76b9",
	"./pages/data-saving/sumary_current_electric.svg": "00b5",
	"./pages/data-saving/sumary_lifetime.svg": "1976",
	"./pages/data-saving/sumary_lifetime_co2.svg": "18d0",
	"./pages/data-saving/sumary_planted_equivalently.svg": "030f",
	"./pages/data-saving/sumary_total_co2.svg": "6500",
	"./pages/data-saving/sumary_total_expense.svg": "ba2c",
	"./pages/device/assets.svg": "b58a",
	"./pages/device/commission-failure.svg": "b455",
	"./pages/device/commission-success.svg": "907c",
	"./pages/device/commission-warning.svg": "7901",
	"./pages/multiple-sites/alarm-status.svg": "5cb7",
	"./pages/multiple-sites/filter.svg": "ffe6",
	"./pages/multiple-sites/menu-bars.svg": "a6df",
	"./pages/multiple-sites/normal-status.svg": "49e2",
	"./pages/multiple-sites/offline-status.svg": "10bb",
	"./pages/multiple-sites/summary-1.svg": "e18a",
	"./pages/multiple-sites/summary-2.svg": "ce80b",
	"./pages/multiple-sites/summary-3.svg": "3278",
	"./pages/multiple-sites/summary-4.svg": "fa0a",
	"./pages/multiple-sites/summary-5.svg": "96097",
	"./pages/multiple-sites/switch-map.svg": "66f1",
	"./pages/multiple-sites/switch-table.svg": "8a16",
	"./pages/single-site/arrow-down-green.svg": "44aa",
	"./pages/single-site/arrow-up-red.svg": "609c",
	"./pages/single-site/circle-1.2.svg": "390a",
	"./pages/single-site/circle-2.2.svg": "dda4",
	"./pages/single-site/circle-3.2.svg": "bf95",
	"./pages/single-site/circle-4.2.svg": "9453",
	"./pages/single-site/energy-1.2.svg": "799c",
	"./pages/single-site/energy-2.2.svg": "ee1c",
	"./pages/single-site/general-1.2.svg": "593c",
	"./pages/single-site/general-2.2.svg": "e096",
	"./pages/single-site/general-3.2.svg": "d773",
	"./pages/single-site/general-4.2.svg": "844c",
	"./pages/single-site/general-5.2.svg": "8e42",
	"./pages/single-site/general-6.2.svg": "2c23",
	"./pages/single-site/solar_house_pattaya.svg": "f9cb",
	"./pages/single-site/unit-b.svg": "42bc",
	"./semp-logo.svg": "3bc5",
	"./single_site.svg": "8f00",
	"./tables/alarm-screen.svg": "0325",
	"./tables/angle_right.svg": "b2a3",
	"./tables/asset_delete.svg": "1e20",
	"./tables/asset_delete_white.svg": "8b4c",
	"./tables/asset_edit.svg": "2033",
	"./tables/asset_edit_white.svg": "5021",
	"./tables/battery_icon_table.svg": "5ab9",
	"./tables/data-analytic-screen.svg": "5604",
	"./tables/delete_icon.svg": "34c3",
	"./tables/device-screen.svg": "13c1",
	"./tables/diagram-icon.svg": "6307",
	"./tables/edit_icon.svg": "2f93",
	"./tables/evse_icon_table.svg": "25aa",
	"./tables/export-btn.svg": "654b",
	"./tables/filter-icon.svg": "d167",
	"./tables/icon_sort_asc_active.svg": "117b",
	"./tables/icon_sort_header.svg": "c8be",
	"./tables/inventory-screen.svg": "b74d",
	"./tables/inventory_delete.svg": "d900",
	"./tables/locked-icon.svg": "0d80",
	"./tables/multi-site-screen.svg": "c69d",
	"./tables/new-status.svg": "086c",
	"./tables/pv_icon_table.svg": "8333",
	"./tables/qr_code_icon.svg": "e068",
	"./tables/resolved-status.svg": "3c78",
	"./tables/setting-icon.svg": "c087",
	"./tables/single-site-screen.svg": "b755",
	"./tables/unlocked-icon.svg": "fe3d",
	"./tables/user-screen.svg": "dab7",
	"./tables/wip-status.svg": "ae77",
	"./user.svg": "0f62",
	"./user_group.svg": "fd7f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";